export enum API_METHOD {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
  OPTIONS = 'OPTIONS',
}

export enum API_STATUS {
  OK = 'OK',
  ERROR = 'ERROR',
  NOT_FOUND = 'NOT_FOUND',
  INVALID = 'INVALID',
}
